$(function() {
    var step1Val = '';
    var step2Val = 'burglar';
    var fire = '';
    var leaks = '';
    var intrusion = '';
    var outdoor = '';
    $(document).on('click', '.js-step1-input', function(e){ 
        console.log(1);
        e.preventDefault(); 
        step1Val = $(this).val();
        console.log(step1Val);
        var parent = $(this).closest('.js-configurator-card');
        if (!$(this).closest('.js-configurator-card').hasClass('is-active')) {
            $('.step1 .js-configurator-card').removeClass('is-active');
            parent.addClass('is-active');

            $('.step1 .next-step').prop("disabled", false);
        }
    });

    $(document).on('click', '.js-next-step', function(e){ 
        e.preventDefault(); 

        if (step1Val != 'apartment') {
            $('.js-outdoor-column').show();
        }
        
        $('#constructorStep1').hide();
        $('#constructorStep2').show();

    });
    $('.js-step2-intrusion').change(function() {
        if ($(this).is(":checked")) {
            intrusion = 'intrusion';
        } else {
            intrusion = '';
        }
        var parent = $(this).closest('.js-configurator-card');
        parent.toggleClass('is-active');
    });
    $('.js-step2-fire').change(function() {
        if ($(this).is(":checked")) {
            fire = ',fire';
        } else {
            fire = '';
        }
        var parent = $(this).closest('.js-configurator-card');
        parent.toggleClass('is-active');
    });
    $('.js-step2-leaks').change(function() {
        if ($(this).is(":checked")) {
            leaks = ',flood';
        } else {
            leaks = '';
        }
        var parent = $(this).closest('.js-configurator-card');
        parent.toggleClass('is-active'); 
    });
    $('.js-step2-outdoor').change(function() {
        if ($(this).is(":checked")) {
            outdoor = ',outdoor';
        } else {
            outdoor = '';
        }
        var parent = $(this).closest('.js-configurator-card');
        parent.toggleClass('is-active'); 
    });

    $(document).on('click', '.js-constructor-link', function(e){ 
        e.preventDefault(); 
        var url = $(this).data('href');

        url += '?step1=' + step1Val + '&step2=' + intrusion + fire + leaks + outdoor;
        window.open(url, '_blank');
    });
});